import React from "react";

const WhyChoose = () => (
  <div className="container">
    <div className="sc-list-info">
      <div className="row">
        <div className="col-sm-4">
          <ul>
            <li>
              <i className="ion-checkmark-circled" />
              Satisfaction élevée
            </li>
            <li>
              <i className="ion-checkmark-circled" />
              Service inégalé
            </li>
            <li>
              <i className="ion-checkmark-circled" />
              Wifi gratuit
            </li>
          </ul>
        </div>
        <div className="col-sm-4">
          <ul>
            <li>
              <i className="ion-checkmark-circled" />
              Délicieux petit déjeuner
            </li>
            <li>
              <i className="ion-checkmark-circled" />
              Service inégalé
            </li>
            <li>
              <i className="ion-checkmark-circled" />
              Catalogue des produits
            </li>
          </ul>
        </div>
        <div className="col-sm-4">
          <ul>
            <li>
              <i className="ion-checkmark-circled" />
              Satisfaction garantie
            </li>
            <li>
              <i className="ion-checkmark-circled" />
              Bar & jardin avec terrasse
            </li>
            <li>
              <i className="ion-checkmark-circled" />
              Bien-être et piscine
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
);

export default WhyChoose;
